import { FeatureFlagsState } from '@/@types'

const state: FeatureFlagsState = {
  flags: {
    isBooGoPromoActive: false,
    runningBlackFriday: 0,
    runningPromotions: 0,
    isLeapYearPromoActive: 0,
  },
}

export default state
